var map = {
	"./gold-anim/gold0.gif": "7711",
	"./gold-anim/gold1.gif": "c120",
	"./gold-anim/gold10.gif": "57b7",
	"./gold-anim/gold11.gif": "6a0d",
	"./gold-anim/gold12.gif": "5050",
	"./gold-anim/gold13.gif": "42ef",
	"./gold-anim/gold14.gif": "8ea1",
	"./gold-anim/gold15.gif": "8637",
	"./gold-anim/gold16.gif": "7599",
	"./gold-anim/gold2.gif": "7b4f",
	"./gold-anim/gold3.gif": "d3f8",
	"./gold-anim/gold4.gif": "e362",
	"./gold-anim/gold5.gif": "1492",
	"./gold-anim/gold6.gif": "895a",
	"./gold-anim/gold7.gif": "21e4",
	"./gold-anim/gold8.gif": "f2e9",
	"./gold-anim/gold9.gif": "e35c",
	"./gold_back.png": "b8c3",
	"./gold_normal.png": "4f59",
	"./gold_shiny.gif": "6a76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c08";